import { APPROVAL_STATUS } from '../approvals/labels';
import type { ChurchForm, FormAnswer, FormField, FormFieldType, FormResponse } from '../../shared/api/types';

export const FIELD_TYPE_LABELS: Record<FormFieldType, string> = {
  text: 'Texto corto',
  textarea: 'Texto largo',
  number: 'Número',
  date: 'Fecha',
  choice: 'Una opción',
  multi: 'Varias opciones',
  checkbox: 'Casilla (sí)',
};

export const FORM_STATUS_LABELS: Record<ChurchForm['status'], string> = { draft: 'Borrador', open: 'Abierto', closed: 'Cerrado' };

export function formatAnswer(field: FormField, value: FormAnswer | undefined): string {
  if (value === undefined) return '';
  if (Array.isArray(value)) return value.join(', ');
  if (field.type === 'checkbox') return value ? 'Sí' : '';
  return String(value);
}

/** CSV (separado por comas, con BOM para que Excel respete los acentos). */
export function responsesCsv(form: ChurchForm, responses: FormResponse[]): string {
  const cell = (v: string) => (/[",\n\r]/.test(v) ? `"${v.replace(/"/g, '""')}"` : v);
  const approval = form.requiresApproval;
  const header = ['Persona', 'Fecha', ...(approval ? ['Aprobación'] : []), ...form.fields.map((f) => f.label)];
  const rows = responses.map((r) => [
    r.person.name,
    new Date(r.submittedAt).toISOString(),
    ...(approval ? [r.approval ? APPROVAL_STATUS[r.approval.status] : ''] : []),
    ...form.fields.map((f) => formatAnswer(f, r.answers[f.key])),
  ]);
  return '﻿' + [header, ...rows].map((row) => row.map(cell).join(',')).join('\r\n');
}
